// oxlint-disable-next-line no-shadow
export enum FEATURE_FLAGS {
  "AUDIO_NOTES" = "AUDIO_NOTES",
  "ALLOW_ALL_USERS_TO_ADD_COMMENTS" = "ALLOW_ALL_USERS_TO_ADD_COMMENTS",
  "DOCUMENTS" = "DOCUMENTS",
  "DOCUMENT_ACKNOWLEDGMENTS" = "DOCUMENT_ACKNOWLEDGMENTS",
  "JHA" = "JHA",
  "CORRECTIVE_ACTIONS" = "CORRECTIVE_ACTIONS",
  "FORMS" = "FORMS",
  "STANDARDS" = "STANDARDS",
  "CONTRACTOR_MANAGEMENT" = "CONTRACTOR_MANAGEMENT",
  "EQUIPMENT_MANAGEMENT" = "EQUIPMENT_MANAGEMENT",
  "TRAINING_CERT" = "TRAINING_CERT",
  "SITE_MANAGEMENT" = "SITE_MANAGEMENT",
  "PEOPLE_MANAGEMENT" = "PEOPLE_MANAGEMENT",
  "DIVISION_MANAGEMENT" = "DIVISION_MANAGEMENT",
  "TO_DO_LIST" = "TO_DO_LIST",
  "PUBLIC_REGISTRATION" = "PUBLIC_REGISTRATION",
  "PUBLIC_SHARE_EQUIPMENT" = "PUBLIC_SHARE_EQUIPMENT",
  "PUBLIC_SHARE_CONTRACTORS" = "PUBLIC_SHARE_CONTRACTORS",
  "PUBLIC_SHARE_DOCUMENTS" = "PUBLIC_SHARE_DOCUMENTS",
  "PUBLIC_SHARE_JOBS" = "PUBLIC_SHARE_JOBS",
  "REPORTS" = "REPORTS",
  "SYSTEM_EXPORT" = "SYSTEM_EXPORT",
  "DEV_ONLY" = "DEV_ONLY",
  "TASKS" = "TASKS",
  "QUEUES" = "QUEUES",
  "NOTIFICATIONS" = "NOTIFICATIONS",
  "DOCUMENTS_OFFLINE" = "DOCUMENTS_OFFLINE",
  "FORMS_OFFLINE" = "FORMS_OFFLINE",
  "VIDEO_MANAGEMENT" = "VIDEO_MANAGEMENT",
  "DASHBOARD" = "DASHBOARD",
  "SCHEDULER" = "SCHEDULER",
  "LANGUAGE" = "LANGUAGE",
  "NONLINEAR_WORKFLOW" = "NONLINEAR_WORKFLOW",
  "WORKFLOW_ROUTING" = "WORKFLOW_ROUTING",
  "NONLINEAR_TRAINING" = "NONLINEAR_TRAINING",
  "PROJECT_MANAGEMENT" = "PROJECT_MANAGEMENT",
  "WEBHOOKS" = "WEBHOOKS",
  "PIN_MAP" = "PIN_MAP",
  "CLIMATE_API" = "CLIMATE_API",
  "DISABLE_BASIC_USER_TRAINING_SELF_MANAGEMENT" = "DISABLE_BASIC_USER_TRAINING_SELF_MANAGEMENT",
  "DISABLE_FORM_DUPLICATION" = "DISABLE_FORM_DUPLICATION",
}

export type TFeatureFlag = {
  name: FEATURE_FLAGS;
};

export type FeatureFlags = Record<FEATURE_FLAGS, boolean>;
export type PartialFeatureFlags = Partial<FeatureFlags>;
export type FeatureFlagInput = FEATURE_FLAGS | TFeatureFlag;
export type FeatureFlagChange = { feature: string; enable: boolean };

export type FeatureFlagSource = {
  featureFlags?: PartialFeatureFlags;
  /**
   * @deprecated legacy feature list. Use featureFlags.
   */
  features?: TFeatureFlag[];
};
